import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStory } from 'shared/actions/storyActions';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import blue from '@material-ui/core/colors/blue';
import TextField from '@material-ui/core/TextField';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { print } from 'shared/utils/Helpers';

const styles = {
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
};

class CreateStory extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      name: '',
      description: '',
    };
  }

  componentWillMount(){
    this.clearAndResetFields();
  }

  onChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
  } 

  clearAndResetFields = () => {
    this.setState({
      name: '',
      description: '',
    });
  }

  handleCreateStory = () => {
    let storyData = {
      name: this.state.name,
      summary: this.state.description
    };
    // print("handleCreateStory storyData: ", storyData);
    this.props.createStory(storyData)
    .then(() => this.props.onSuccess())
    .catch(err => alert(err.error));
  }

  render() {
    const { classes, onClose, selectedValue, ...other } = this.props;

    // print("...other", ...other);

    return (
      <Dialog onClose={this.props.onClose} aria-labelledby="form-dialog-title" open={this.props.open}>
        <DialogTitle id="form-dialog-title">Add Story</DialogTitle>
        <DialogContent>
        <TextField
              autoFocus
              margin="dense"
              name="name"
              id="name"
              label="Add story name"
              // type="email"
              fullWidth
              value={this.state.name}
              // onChange={event => this.setState({name: event.target.value})}
              onChange={this.onChange}
            />
            <TextField
              margin="dense"
              name="description"
              id="name"
              label="Add description"
              // type="email"
              fullWidth
              value={this.state.description}
              onChange={this.onChange}
              // onChange={event => this.setState({description: event.target.value})}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleCreateStory} color="primary">
              Add
            </Button>
          </DialogActions>
      </Dialog>
    );
  }
}

CreateStory.propTypes = {
  classes: PropTypes.object.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
};

export default connect(null, { createStory })(withStyles(styles, { withTheme: true })(CreateStory));
